import { useCallback, useContext, useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom'
import { faAngleDoubleLeft, faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons"

import { ApplicationContext } from 'context'

import Sign from 'components/Sign'
import ButtonPrimary from "components/ButtonPrimary"

import { discectError } from "lib/utils"
import api from 'lib/api'

import styles from "./styles.module.scss"

const OnBoardingSign = ({ token, surety, requirements, onGetToken, onRefresh }) => {
  const { contextError, contextLoading, useCurrentPath } = useContext(ApplicationContext)
  const [isLoading, setIsLoading] = contextLoading // eslint-disable-line
  const [_, setError] = contextError // eslint-disable-line
  const [requests, setRequests] = useState(null)
  const [request, setRequest] = useState(null)
  const [type, setType] = useState(null)

  const navigate = useNavigate()

  const currentPath = useCurrentPath()

  const { files, fileDetails } = requirements

  useEffect(() => {
    if (!type) {
      if (currentPath === '/onboarding/sign/contract') {
        setType('CONTACTS')
      } else {
        setType('FILES')
      }
    }
  }, [currentPath, type])

  const _fetchRequests = useCallback(async () => {
    try {
      const tokenResults = await onGetToken(token)
      if (tokenResults) {

        const { requests: userRequests } = await api.warehouse.fetchAnswerGroupRequests(token, tokenResults.token)

        let fileRequests = userRequests.filter(itm => {
          const currentFile = fileDetails.find(f => f.id === itm.fileId)
          if (currentPath === '/onboarding/sign/contract' && currentFile.isContract) {
            return true
          } else if (currentPath === '/onboarding/sign' && !currentFile.isContract) {
            return true
          }
          return false
        })

        setRequests(() => fileRequests)
      }
    } catch(e) {
      setError(discectError(e))
    }
  }, [token, currentPath, fileDetails, onGetToken, setError])

  useEffect(() => {
    if (token && !requests) _fetchRequests() 
  }, [token, requests, _fetchRequests])

  // Actios

  const  _onSave = async ({ submissionId }) => {
    setIsLoading(true)
    try {
      const tokenResults = await onGetToken(token)
      if (tokenResults) {
        const { request } = await api.warehouse.markRequestComplete(token, { submissionId }, tokenResults.token) // isComplete
        if (request) {
          setRequest(null)
        }
        await onRefresh(['REQUESTS'])
        setIsLoading(false)
      }
      await _fetchRequests()
    } catch(e) {
      setError(discectError(e))
      setIsLoading(false)
    }
  }

  // Signing Actions

  const _doSign = async (docId) => {
    setIsLoading(true)

    try {
      document.getElementById('visualForm').innerHTML = ''

      const doc = requests.find(itm => itm.id === docId)
      if (doc) {
        const tokenResults = await onGetToken(token)
        if (tokenResults) {
          const { request } = await api.warehouse.fetchDocumentRequest(token, doc.id, tokenResults.token)
          if (request) {
            // if (request.status === 'COMPLETED') {
            //   // _onSave({ submissionId: request.submissionId})
            //   // window.DocSpring.closeModal()
            // } else {
            //   setRequest(request)
            // }
            setRequest(request)
            setIsLoading(false)
          } else {
            throw new Error('Document URL was invalid.')
          }
        }
      } else {
        throw new Error('Document was not found.')
      }
    } catch(e) {
      console.error(e)
      setIsLoading(false)
    }
  }

  // Layout

  const _isDisabled = () => {
    let isComplete = true
    requests.forEach(r => {
      if (!r.isComplete) isComplete = false
    })
    return !isComplete
  }

  const _getRequests = () => {
    if (files.length) {
      return files.filter(itm => {
          const currentFile = fileDetails.find(f => f.id === itm.fileId)
          if (type === 'CONTACTS' && currentFile.isContract) {
            return true
          } else if (type === 'FILES' && !currentFile.isContract) {
            return true
          }
          return false
      }).map((itm, key) => {
        const currentFile = fileDetails.find(f => f.id === itm.fileId)
        console.log(currentFile)
        return (
          <div key={key} className={styles.sign__doc}>
            <h4>{itm.name}</h4>
            {itm.isComplete && <div className={styles.bigTile}>Signed!</div>}
            {!itm.isComplete && <ButtonPrimary color="teal" onClick={() => _doSign(itm.id)}>Sign</ButtonPrimary>}
          </div>
        )
      })
    }
    return null
  }

  const _getCompleteButton = () => {
    if (requests) {
      return (
        <footer className={styles.sign__footer}>
          <div>
            <ButtonPrimary color="grey" icon={faAngleDoubleLeft} onClick={() => navigate('/onboarding')}>Back</ButtonPrimary>
          </div>
          <div>
            <ButtonPrimary isIconRightSide color="navy" icon={faAngleDoubleRight} onClick={() => navigate('/onboarding')} disabled={_isDisabled()}>Continue</ButtonPrimary>
          </div>
        </footer>
      )
    }
    return null
  }

  return (
    <>
      <div className={styles.sign}>
        <header className={styles.primaryHeader}>
          <h2>Sign</h2>
          <p>Below are a list of files we need a signature on.</p>
        </header>
        {(files && surety && requirements) && _getRequests()}
        {_getCompleteButton()}
      </div>
      {request && <Sign request={request} onClose={() => setRequest(null)} onSave={_onSave} />}
    </>
  )
}

export default OnBoardingSign
